import router from '#app/router'
import { combinePaths } from '../strings'

export default function getTgBotRole() {
  const pathname = window.location.pathname

  if (pathname.startsWith(combinePaths(router.basepath, '/client'))) {
    return 'client'
  }

  if (pathname.startsWith(combinePaths(router.basepath, '/staff'))) {
    return 'staff'
  }

  throw new Error('Unsupported role')
}
